import {useId,View} from "vritra";
import css from "./Preview.module.css";
import {DraggableView} from "vritra";


export default function Preview(props){
    const {parent,id=useId("preview")}=props;
    const preview=View({parent,id,className:css.preview});

    preview.innateHTML=`
    `;

    statics.viewsprops.forEach((viewprops,i)=>{
        const view=DraggableView({
            ...viewprops,
            parent:preview,
            style:`background-color:${[majorColor,mainColor,minorColor][i%3]};`,
            className:css.draggableview,
            onDrop:(_,element)=>{
                element.setPosition({x:0,y:0,duration:statics.duration});
            },
        });
        view.innateHTML=`
            <h3>${viewprops.message||""}</h3>
        `;
    });

    return preview;
}

const statics={
    duration:200,
    viewsprops:[
        {
            message:"drag me vertically",
            horizontalDrag:false,
        },
        {
            message:"drag me horizontally",
            verticalDrag:false,
        },
        {message:"drag me"},
    ],
};
